import { css } from "@emotion/react";
import Image from "next/image";

import { PC_BENTO_WIDTH } from "~/components/me/bento/containers/BentoItemContainer";
import { PC_BENTO_ITEM_GAP_SIZE } from "~/components/me/bento/containers/BentoItemRow";
import useIsSpMode from "~/lib/client/hooks/useIsSpMode";
import { cdnFileUrl } from "~/lib/environment";

const PC_IMAGE_PATH = "/images/mypage-content-will-be-update.png";
const SP_IMAGE_PATH = "/images/My-Page-Content-SP.png";

const ContentWillCreateBanner = () => {
  const isSpMode = useIsSpMode();
  const imagePath = isSpMode ? SP_IMAGE_PATH : PC_IMAGE_PATH;

  if (typeof isSpMode === "undefined") return null;

  return (
    <Image
      src={cdnFileUrl(imagePath)}
      alt={"コンテンツは準備中です！"}
      width={isSpMode ? 365 : PC_BENTO_WIDTH * 3 + PC_BENTO_ITEM_GAP_SIZE * 2}
      height={isSpMode ? 180 : 230}
      css={imageStyle}
      layout={"fixed"}
    />
  );
};

const imageStyle = css`
  border-radius: 20px;
  margin: -0.25rem;
`;

export default ContentWillCreateBanner;
